import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set initial time to 15 minutes from now
    const endTime = new Date().getTime() + 15 * 60 * 1000;
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        clearInterval(timer);
        // Reset to 15 minutes when timer expires
        const newEndTime = new Date().getTime() + 15 * 60 * 1000;
        setTimeLeft({
          hours: 0,
          minutes: 15,
          seconds: 0
        });
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-gradient-to-r from-red-600 to-orange-600 text-white py-3 px-4 rounded-lg shadow-lg" data-id="element-514">
      <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-515">
        <div className="flex items-center gap-2" data-id="element-516">
          <Clock className="w-5 h-5 animate-pulse" data-id="element-517" />
          <span className="font-bold text-sm md:text-base" data-id="element-518">
            Special Offer Ends In:
          </span>
        </div>
        <div className="flex gap-2" data-id="element-519">
          {timeLeft.hours > 0 && <>
              <div className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-md min-w-[3rem] text-center" data-id="element-520">
                <div className="text-2xl font-bold" data-id="element-521">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <div className="text-xs uppercase" data-id="element-522">Hours</div>
              </div>
              <div className="text-2xl font-bold self-center" data-id="element-523">:</div>
            </>}
          <div className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-md min-w-[3rem] text-center" data-id="element-524">
            <div className="text-2xl font-bold" data-id="element-525">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <div className="text-xs uppercase" data-id="element-526">Min</div>
          </div>
          <div className="text-2xl font-bold self-center" data-id="element-527">:</div>
          <div className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-md min-w-[3rem] text-center" data-id="element-528">
            <div className="text-2xl font-bold" data-id="element-529">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <div className="text-xs uppercase" data-id="element-530">Sec</div>
          </div>
        </div>
      </div>
    </div>;
}